import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Button } from '@material-ui/core';
import { Box, Card } from '@mui/material';
import { DataGrid } from '@material-ui/data-grid';
import DoNotDisturbOn from '@mui/icons-material/DoNotDisturbOn';
import useStyles from './styles';
import ApiService from '../../services/ApiService';
import ActualWorkshopsPopupButton from './ActualWorkshopsPopupButton';
import AddWorkshopPopUp from './AddWorkshopPopUp';

export default function ActualWorkshopsPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [actualWorkshops, setActualWorkshops] = useState();
  const [openActualWorkshopsPopup, setOpenActualWorkshopsPopup] =
    useState(false);
  const [workshopName, setWorkshopName] = useState();
  const [removedWorkShop, setRemovedWorkShop] = useState();

  const columns = [
    {
      field: 'actions',
      headerName: ' ',
      type: 'action',
      width: 50,
      renderCell: () => {
        return (
          <DoNotDisturbOn
            // className={classes.addIcon}
            style={{ color: '#DF0C36' }}
          />
        );
      },
    },
    {
      field: 'workshopsName',
      headerName: 'Workshop Name',
      width: 200,
      editable: true,
    },
  ];

  const getWorkShopList = () => {
    ApiService.getAllActualWorkshops()
      .then((response) => {
        setActualWorkshops(response.data);
      })
      .catch((error) => {
        console.log('Unable to get Actual Workshops', error);
      });
  };

  useEffect(() => {
    getWorkShopList();
  }, [openActualWorkshopsPopup === false]);

  const handleClickOpen = () => {
    setOpenActualWorkshopsPopup(true);
  };

  const handleClose = () => {
    setOpenActualWorkshopsPopup(false);
    console.log(openActualWorkshopsPopup);
  };

  const onClickRemoveWorkshop = () => {
    ApiService.removeActualWorkshop(workshopName)
      .then((response) => {
        setRemovedWorkShop(response.data);
      })
      .catch((error) => {
        console.log('Unable to remove workshop in the list', error);
      });
  };

  useEffect(() => {
    getWorkShopList();
  }, [removedWorkShop]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <Typography className={classes.title}>
            {t('actual_workshops')}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          {workshopName && (
            <Button
              className={classes.removeButton}
              onClick={() => onClickRemoveWorkshop()}
              // disabled={workshopName === undefined}
            >
              <DoNotDisturbOn />
              {t('remove_workshop')}
            </Button>
          )}
        </Grid>
        <Grid item xs={2}>
          <ActualWorkshopsPopupButton handleClickOpen={handleClickOpen} />
          <AddWorkshopPopUp
            open={openActualWorkshopsPopup}
            setPopUpOpenedState={handleClose}
          />
        </Grid>
      </Grid>
      <Card>
        <Box sx={{ height: 460, width: '100%' }}>
          {actualWorkshops && (
            <DataGrid
              rows={actualWorkshops}
              columns={columns}
              pageSize={20}
              rowsPerPageOptions={[20]}
              getRowId={(row) => row.workshopsName}
              onRowSelected={(selectedData) => {
                setWorkshopName(selectedData.data.workshopsName);
              }}
            />
          )}
        </Box>
      </Card>
    </div>
  );
}
